<p class="mb-6 text-generic">
    {{ 'BUSINESS_ACTIVITY.ENTER_DETAILS' | translate }}
</p>

<form [formGroup]="businessActivityForm" class="space-y-8" (ngSubmit)="handleFormSubmission()">
    <!-- Responsive grid -->
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8">
        <!-- Purpose of Business Relationship -->
        <div>
            <app-custom-dropdown label="BUSINESS_ACTIVITY.PURPOSE_OF_BUSINESS_RELATIONSHIP"
                placeholder="BUSINESS_ACTIVITY.PLEASE_SELECT" [options]="purposeOfBusinessRelOptions"
                (optionSelected)="onDropdownSelect('purposeOfBusinessRelationship', $event)"
                customClass="!mb-0"></app-custom-dropdown>
        </div>

        <!-- Empty space for alignment -->
        <div class="sm:block hidden"></div>

        <!-- Types of expected transaction -->
        <div class="sm:col-span-2">
            <app-checkbox-group label="BUSINESS_ACTIVITY.TYPES_OF_EXPECTED_TRANSACTION"
                [options]="typesOfExpectedTransactionOption"
                [control]="getControl('typesOfExpectedTransaction')"></app-checkbox-group>
        </div>

        <!-- Total expected transaction -->
        <div>
            <app-custom-dropdown label="BUSINESS_ACTIVITY.TOTAL_EXPECTED_TRANSACTION"
                placeholder="BUSINESS_ACTIVITY.PLEASE_SELECT"
                (optionSelected)="onDropdownSelect('totalExpectedTransaction', $event)"
                [options]="totalExpectedTransactionOptions" customClass="!mb-0"></app-custom-dropdown>
            <p class="mt-2 text-(--text-secondary) text-sm">
                {{ 'BUSINESS_ACTIVITY.EXPECTED_TOTAL_AMOUNT_ANNUALLY' | translate }}
            </p>
        </div>

        <!-- Empty for alignment -->
        <div class="sm:block hidden"></div>

        <!-- Multinational companies -->
        <p class="text-medium sm:col-span-2">{{ 'BUSINESS_ACTIVITY.MULTINATIONAL_COMPANIES' | translate }}</p>
        <div class="sm:col-span-2 flex flex-wrap gap-4">
            <div *ngFor="let c of getControl('multiNationalCompanies').value"
                class="border bg-transparent border-(--brand-primary) py-2.5 px-6 flex justify-between items-center gap-2.5 rounded-full">
                <img [src]="c.icon" *ngIf="c.icon" alt="Flag" class="rounded-full w-4 h-4" />
                <p class="text-(--brand-primary) font-medium text-sm">{{ c.label }}</p>
                <button type="button" (click)="removeCountry('multiNationalCompanies', c)"
                    class="cursor-pointer transition hover:opacity-85">
                    <img src="assets/icons/cancel-blue.svg" class="w-3 h-3" alt="remove" />
                </button>
            </div>

            <button type="button" (click)="addMultiNationalCompany()"
                class="bg-(--brand-primary) py-2.5 px-6.5 rounded-[100px] flex justify-center items-center gap-2 font-medium text-sm text-white cursor-pointer transition hover:opacity-95">
                <img src="assets/icons/add-white.svg" class="w-3 h-3" alt="icon" />
                {{
                (getControl('multiNationalCompanies').value?.length || 0) > 0
                ? ('BUSINESS_ACTIVITY.ADD_MORE_COUNTRY' | translate)
                : ('BUSINESS_ACTIVITY.ADD_COUNTRY' | translate)
                }}
            </button>
        </div>

        <!-- Expected countries of dealings -->
        <p class="text-medium sm:col-span-2">{{ 'BUSINESS_ACTIVITY.EXPECTED_COUNTRIES_OF_DEALINGS' | translate }}</p>
        <div class="sm:col-span-2 flex flex-wrap gap-4">
            <div *ngFor="let c of getControl('expectedCountriesOfDealings').value"
                class="border bg-transparent border-(--brand-primary) py-2.5 px-6 flex justify-between items-center gap-2.5 rounded-full">
                <img [src]="c.icon" *ngIf="c.icon" alt="Flag" class="rounded-full w-4 h-4" />
                <p class="text-(--brand-primary) font-medium text-sm">{{ c.label }}</p>
                <button type="button" (click)="removeCountry('expectedCountriesOfDealings', c)"
                    class="cursor-pointer transition hover:opacity-85">
                    <img src="assets/icons/cancel-blue.svg" class="w-3 h-3" alt="remove" />
                </button>
            </div>

            <button type="button" (click)="addExpectedCountryDealings()"
                class="bg-(--brand-primary) py-2.5 px-6.5 rounded-[100px] flex justify-center items-center gap-2 font-medium text-sm text-white cursor-pointer transition hover:opacity-95">
                <img src="assets/icons/add-white.svg" class="w-3 h-3" alt="icon" />
                {{
                (getControl('expectedCountriesOfDealings').value?.length || 0) > 0
                ? ('BUSINESS_ACTIVITY.ADD_MORE_COUNTRY' | translate)
                : ('BUSINESS_ACTIVITY.ADD_COUNTRY' | translate)
                }}
            </button>
        </div>
    </div>

    <!-- Submit Button -->
    <app-button text="{{ 'BUSINESS_ACTIVITY.CONTINUE' | translate }}" type="submit" variant="primary" size="lg"
        extraClass="mt-3 mb-12 w-full" [disabled]="businessActivityForm.invalid"></app-button>
</form>